export const projectFormData = () => ({
  inputData: {
    project_code: "",
    project_name: "",
    customer_id: null,
    contact_person_details: [
      {
        contact_person_name: "",
        contact_person_email: "",
        contact_person_mobile: "",
      },
    ],
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "projects",
    whereCondition: {
      is_active: true,
    },
  };

  const navigatePage = { back: "/project-list" };

  const headerName = "Project";

  const validationType = "ProjectCreate";
  const createEndpoint = "/createProject";
  const updateEndpoint = "/updateProject";
  const getEndpoint = "/getProjectById";


  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const exportPageData = {
  data: { "modelName": "projects", "relations": [{ "module": "company_masters", "moduleAs": "company" }], "search": { "field_name": ["project_code", "project_name", "company.company_name"], "searchKeyword": "" }, "pagination": { "page": 1, "pageSize": 10000 } },
  fileName: "projectData.xlsx"
};